export default {"src":"/_next/static/media/tick-circle.6c733720.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};